export const getWidthProperty = (onlyIcon?: boolean, fullWidth?: boolean) =>
  onlyIcon && !fullWidth ? 'width' : 'min-width'
